export default "__VITE_ASSET__9xcVYJpd__"